import { Fragment, Suspense, lazy } from "react"

import { ClientOnly, FieldError, Spinner } from "@trueskin-web/components"

import { usePhotos } from "./image-upload-hooks"
import PhotoSlot from "./photo-slot"
import { photosUploadSteps } from "./resources"

const SortablePhotos = lazy(() => import("./sortable-photos"))

const PhotoSlots = ({ ...props }) => {
  const {
    photos,
    handleAdd,
    handleAddMultiple,
    handleRemove,
    isUploadImagesLoading,
    uploadError,
  } = usePhotos()

  return (
    <Fragment>
      <div sx={{ position: "relative", mt: 7, mb: 4 }}>
        <div
          sx={{
            display: "flex",
            gap: 3,
            pointerEvents: "none",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {photosUploadSteps.map((_, index) => (
            <PhotoSlot key={index} />
          ))}
        </div>

        <ClientOnly>
          <Suspense fallback={<div />}>
            <SortablePhotos
              photos={photos}
              axis="x"
              onAdd={handleAdd}
              onAddMultiple={handleAddMultiple}
              onRemove={handleRemove}
            />
          </Suspense>
        </ClientOnly>
      </div>

      <div
        sx={{ mt: 4, display: "flex", gap: 3, textAlign: "center" }}
        {...props}
      >
        {photosUploadSteps.map(({ title, description }, index) => (
          <div key={index} sx={{ flex: 1 }}>
            <div sx={{ fontSize: 1, color: "text" }}>{title}</div>
            <div sx={{ mt: 2, fontSize: 0 }}>{description}</div>
          </div>
        ))}
      </div>

      {uploadError && (
        <FieldError sx={{ mt: 4 }}>Error {uploadError.message}</FieldError>
      )}

      {isUploadImagesLoading && (
        <div
          sx={{
            display: "grid",
            placeItems: "center",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "rgba(255, 255, 255, 0.85)",
          }}
        >
          <Spinner />
        </div>
      )}
    </Fragment>
  )
}

export default PhotoSlots
